<script setup>
const addons = [
  {
    id: "booking",
    label: "System rezerwacji",
    price: 3000,
    desc:
      "Pozwól klientom umawiać się na wizyty, spotkania czy usługi 24/7 — bez dzwonienia, bez maili, bez chaosu. Idealne dla salonów, konsultantów, usług lokalnych.",
  },
  {
    id: "payments",
    label: "System płatności online",
    price: 5000,
    desc:
      "Sprzedawaj od razu — usługi, produkty, vouchery. Zintegrujemy Twoją stronę z bezpiecznymi płatnościami, które ułatwiają decyzje zakupowe.",
  },
  {
    id: "i18n",
    label: "Strona wielojęzyczna",
    price: 1200,
    desc:
      "Masz klientów z zagranicy? Pokaż, że jesteś na to gotowy. Wersje językowe budują profesjonalny wizerunek i zwiększają zasięg Twojej oferty.",
  },
  {
    id: "dynamic_content",
    label: "Blog / Nowości / Wydarzenia",
    price: 1500,
    desc:
      "Regularne aktualizacje przyciągają ruch, budują zaufanie i poprawiają SEO. Dodaj sekcję z aktualnościami, wpisami czy wydarzeniami, którą łatwo zaktualizujesz.",
  },
  {
    id: "cms",
    label: "Panel CMS (system do edycji treści)",
    price: 2500,
    desc:
      "Chcesz samodzielnie aktualizować teksty, zdjęcia, wpisy? Zyskaj kontrolę nad stroną — bez proszenia kogokolwiek o pomoc.",
  },
  {
    id: "gmb",
    label: "Umieszczenie firmy w Google Business / Maps",
    price: 800,
    desc:
      "Zadbaj o to, by klienci mogli Cię łatwo znaleźć w Google i sprawdzić opinie, godziny otwarcia czy lokalizację. Idealne dla biznesów lokalnych.",
  },
  {
    id: "gsc",
    label: "Wdrożenie Google Search Console",
    price: 200,
    desc:
      "Chcesz wiedzieć, jak Google widzi Twoją stronę? To narzędzie daje możliwość wglądu w statystyki strony i pomoże Ci lepiej pozycjonować się w wyszukiwarce.",
  },
  {
    id: "ga",
    label: "Wdrożenie Google Analytics",
    price: 600,
    desc:
      "Dowiedz się, kto odwiedza Twoją stronę, skąd przychodzi i co go interesuje. To dane, które pomogą podejmować lepsze decyzje marketingowe.",
  },
];

const selected = ref([]);

const picked = computed(() => addons.filter((a) => selected.value.includes(a.id)));
const price = computed(() => picked.value.reduce((sum, a) => sum + a.price, 0));

defineExpose({
  picked,
  price,
});
</script>

<template>
  <article>
    <header class="mb-3">
      <h2 class="text-xl font-semibold tracking-tight text-slate-900">
        🔧 Dodatkowe funkcje i integracje
      </h2>
      <p class="mt-1.5 text-slate-600">
        Chcesz, by Twoja strona nie tylko wyglądała dobrze, ale też działała na Twoją
        korzyść? Wybierz dodatki, które automatyzują działania, zwiększają zasięg i
        pomagają zdobywać klientów.
      </p>
    </header>

    <!-- Lista kompaktowa: jedna pozycja w wierszu -->
    <div
      role="group"
      aria-label="Wybór dodatków"
      class="grid grid-cols-1 md:grid-cols-2 gap-3"
    >
      <label
        v-for="a in addons"
        :key="a.id"
        class="group relative flex items-start gap-3 rounded-xl border border-slate-200 bg-white p-3 shadow-sm transition hover:shadow-md"
        :class="selected.includes(a.id) ? 'ring-2 ring-slate-900 bg-slate-50' : ''"
        @click="
          selected.includes(a.id)
            ? (selected = selected.filter((id) => id !== a.id))
            : selected.push(a.id)
        "
      >
        <!-- Ikona -->
        <div
          class="grid w-9 shrink-0 aspect-square place-items-center rounded-lg bg-gradient-to-br from-slate-900 to-slate-700 text-white shadow"
        >
          🔌
        </div>

        <!-- Tytuł + opis -->
        <div class="min-w-0 flex-1">
          <div class="flex items-baseline justify-between gap-2">
            <h3 class="text-[15px] font-semibold text-slate-900">
              {{ a.label }}
            </h3>
            <div class="ml-2 flex shrink-0 items-baseline gap-1">
              <span class="text-xl font-semibold text-slate-900">{{ a.price }}</span>
              <span class="text-xs text-slate-500">zł</span>
            </div>
          </div>
          <p :id="`${a.id}-desc`" class="mt-0.5 text-sm text-slate-600">
            {{ a.desc }}
          </p>
        </div>
      </label>
    </div>
  </article>
</template>
